import { spacing, Text } from "@minuthq/meatball-ui-react"

import { TCancelPlanForm } from "src/components/Account/BillingPortal/YourPlan/CancelPlanDialogWizard/useCancelPlanForm"
import { useTranslate } from "src/i18n/useTranslate"
import { PhoneNumberInput } from "src/ui/PhoneNumberInput/PhoneNumberInput"

export const CANCEL_PLAN_CONTACT_FORM_ID = "cancel-plan-contact-form"

export function CancelPlanContactStep({
  form,
  onSubmit,
}: {
  form: TCancelPlanForm
  onSubmit: () => void
}) {
  const { t, langKeys } = useTranslate()

  return (
    <form
      id={CANCEL_PLAN_CONTACT_FORM_ID}
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
    >
      <Text variant="heading3" marginBottom={spacing.XS}>
        {t(langKeys.cancel_plan_phone_title)}{" "}
        <Text as="span" variant="bodyS">
          ({t(langKeys.input_optional)})
        </Text>
      </Text>

      <Text marginBottom={spacing.M}>
        {t(langKeys.cancel_plan_phone_description)}
      </Text>

      <PhoneNumberInput
        value={form.values.phoneNumber}
        onChange={(value) =>
          form.setValues((prev) => ({
            ...prev,
            phoneNumber: value?.toString() ?? "",
          }))
        }
        required
      />
    </form>
  )
}
